import { Icon } from 'tabler-icons-react';

export interface StrikethroughIconProps extends Partial<React.SVGProps<SVGSVGElement>> {
  icon: Icon;
  size?: string | number;
  isStrikethrough?: boolean;
}

const StrikethroughIcon = ({
  icon: IconComponent,
  isStrikethrough = false,
  color,
  stroke = 'currentColor',
  strokeWidth = 2,
  size = 24,
  ...props
}: StrikethroughIconProps) => {
  if (!isStrikethrough) {
    return <IconComponent color={color} strokeWidth={strokeWidth} size={size} {...props} />;
  }

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
      }}
    >
      <IconComponent color={color} strokeWidth={strokeWidth} size={size} {...props} />
      <svg
        viewBox="0 0 24 24"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
        }}
      >
        <line
          x1="3"
          y1="3"
          x2="21"
          y2="21"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default StrikethroughIcon;
